 


<template>
	<div class="about-xs" style="position:relative;">

		<div class="aw-register-box about-box">
			<div class="mod-body clearfix gxgd">
				<div class="content   aboutx">
					<h1 style="color: #2d8cf0;">1.3、什么是SQL</h1>
					<h2 class="about-cs">1.3.1、官方描述</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp; 结构化查询语言(Structured Query
						Language)简称SQL，结构化查询语言是一种数据库查询和程序设计语言，用于存取数据以及查询、更新和管理关系数据库系统；sql
						语句就是对数据库进行操作的一种语言。
					</div>
					<h2 class="about-cs">1.3.2、通俗语言描述</font>
					</h2>
					<div class="about-t">
						&nbsp; &nbsp;&nbsp; &nbsp;  把数据库比如一碗米饭，里面放的米是数据。现在我们要吃碗里的米饭，怎么取出碗里的米饭呢？这时候我们拿一双筷子，用筷子操作碗里的米饭。这里的筷子就是SQL，用来操作数据库里的数据。
					</div>
					 
					 
				</div>
			</div>
		</div>
	</div>
</template>


 <script>
 	 
 	export default {
 		components: {
 			 
 		},
 
 		data() {
 			return {
  
 			}
 		},
 
 		 
 		methods: {
 
 			showNote() {
 				 
 					this.$Message.info('介绍在线编辑器！');
 				 
 			}
 
 		},
 
 	}
 </script>

<style lang="scss"  scoped>
	#vip{
		color: red;
		
	}
	
	.about-xs {
		
		margin-bottom: 20px;
		margin-top: 10px;
		margin: 20px;
	}

	//标题字体
  .content h2.about-cs {
		padding-top: 10px;
		color: #2d8cf0;
		font-size: 24px;
		height: 50px;
		text-align: left;
		font-weight: bold;
	}

	//内容字体	
  .content .about-t {
		width: 1040px;
		height: auto;
		overflow: hidden;
		text-align: left;
		font-size: 18px;
		line-height: 60px;
	}


	.aw-register-box .mod-body .content .about-t .at-r {
		width: 596px;
		height: auto;
		float: right;
		text-align: center;
	}

	.aw-register-box .mod-body {
		padding: 10px 10px 10px 10px;
	}

	.aw-register-box .gxgd {
		padding: 10px 10px 10px 10px;
	}


	.about-box {
		width: 1170px;
		margin: 10px;
		background-color: #fff;
		border-radius: 0;
		-webkit-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		-moz-box-shadow: 0 0 4px rgba(0, 0, 0, .1);
		box-shadow: 0 0 4px rgba(0, 0, 0, .1);
	}




	.aw-register-box .mod-body .content .about-t .at-l {
		width: 442px;
		height: auto;
		padding-top: 80px;
		float: left;
		text-align: left;
	}

	.aw-register-box .mod-body .content .about-t .at-l2 {
		width: 496px;
		height: auto;
		float: left;
		text-align: center;
	}

	.aw-register-box .mod-body .content h2.about-cs font {
		color: #e37626;
		font-size: 24px;
	}

	.aw-register-box .mod-bodyx .content h2 {
		margin: 0 0 13px 0;
		color: #333;
		font-size: 18px;
	}

	.aw-register-box .mod-body .content h2.t-center {
		text-align: center;
	}
 
	.aw-register-box .mod-body .mod-bodyt h2.t-center {
		text-align: center;
	}
</style>
